

// const sidebar = (tenantId) => [
//   {
//         title: "Post",
//         icon: "bi-camera-fill",
//         childrens: [
//       {
//         title: "Timeline Posts",
//         icon: "bi-hourglass-split",
//         path: `/${tenantId}/post`,
//       },
//     ],
//   },
//   {
//     title: "Membership",
//     icon: "bi-person-badge-fill",
//     childrens: [
//       {
//         title: "Members",
//         icon: "bi-people-fill",
//         path: `/${tenantId}/members`,
//       },
//       {
//         title: "Add Member",
//         icon: "bi-person-plus-fill",
//         path: `/${tenantId}/memberAdd`,
//       },
//     ],
//   },
//   {
//     title: "Events",
//     icon: "bi-calendar2-event-fill",
//     childrens: [
//       {
//         title: "Events",
//         icon: "bi-calendar3-week",
//         path: `/${tenantId}/events`,
//       },
//       {
//         title: "Add Event",
//         icon: "bi-calendar2-plus-fill",
//         path: `/${tenantId}/eventAdd`,
//       },
//       {
//         title: "Scheduled Posts",
//         icon: "bi-clock-history",
//         path: `/${tenantId}/media/scheduled`,
//       },
//       {
//         title: "Event History",
//         icon: "bi bi-hourglass-split",
//         path: `/${tenantId}/eventHistory`,
//       },
//       {
//         title: "Calendar",
//         icon: "bi-calendar3",
//         path: `/${tenantId}/calendar`,
//       },
//     ],
//   },
//   {
//     title: "Dashboard",
//     icon: "bi-house-door-fill",
//     childrens: [
//       {
//         title: "Home",
//         icon: "bi-house-fill",
//         path: `/${tenantId}/dashboard`,
//       },
//     ],
//   },
//   {
//     title: "Settings",
//     icon: "bi-gear-fill",
//     childrens: [
//       {
//         title: "Add User",
//         icon: "bi-person-plus-fill",
//         path: `/${tenantId}/userAdd`,
//       },
//       {
//         title: "Tenant Users",
//         icon: "bi-people-fill",
//         path: `/${tenantId}/tenantUsers`,
//       },
//       {
//         title: "Integrations",
//         icon: "bi-share",
//         path: `/${tenantId}/integrations`,
//       },
//       {
//         title: "Account",
//         icon: "bi-gear-fill",
//         path: `/${tenantId}/settings`,
//       },
//       {
//         title: "Reset Password",
//         icon: "bi-key-fill",
//         path: `/${tenantId}/reset-password`,
//       },
//       {
//         title: "Terms Of Use",
//         icon: "bi-file-earmark-text",
//         path: "/termsofuse",
//       },
//       {
//         title: "Privacy Policy",
//         icon: "bi-shield-lock-fill",
//         path: "/privacypolicy",
//       },
//       {
//         title: "Profile",
//         icon: "bi-person-circle",
//         path: "/profile",
//       },
//       {
//         title: "Payment",
//         icon: "bi-credit-card-2-front-fill",
//         path: "/settings/billing/payment",
//       },
//       {
//         title: "Subscription",
//         icon: "bi-receipt",
//         path: "/settings/billing/subscription",
//       },
//       {
//         title: "Notifications",
//         icon: "bi-bell-fill",
//         path: "/settings/notifications",
//       },
//     ],
//   },
// ];

// export default sidebar;




const sidebar = (tenantId) => [
  {
    title: "Dashboard",
    icon: "bi-house-door-fill",
    childrens: [
      {
        title: "Home",
        icon: "bi-house-fill",
        path: `/${tenantId}/dashboard`,
      },
    ],
  },
  {
        title: "Post",
        icon: "bi-camera-fill",
        childrens: [
      {
        title: "New Post",
        icon: "bi-send-plus-fill",
        path: `/${tenantId}/post/new`,
      },
      {
        title: "Timeline Posts",
        icon: "bi-hourglass-split",
        path: `/${tenantId}/post`,
      },
    ],
  },
  {
    title: "Events",
    icon: "bi-calendar2-event-fill",
    childrens: [
      {
        title: "Events",
        icon: "bi-calendar3-week",
        path: `/${tenantId}/events`,
      },
      {
        title: "Add Event",
        icon: "bi-calendar2-plus-fill",
        path: `/${tenantId}/eventAdd`,
      },
      {
        title: "Scheduled Posts",
        icon: "bi-clock-history",
        path: `/${tenantId}/media/scheduled`,
      },
      {
        title: "Event History",
        icon: "bi bi-hourglass-split",
        path: `/${tenantId}/eventHistory`,
      },
      {
        title: "Calendar",
        icon: "bi-calendar3",
        path: `/${tenantId}/calendar`,
      },
    ],
  },
  {
    title: "Membership",
    icon: "bi-person-badge-fill",
    childrens: [
      {
        title: "Members",
        icon: "bi-people-fill",
        path: `/${tenantId}/members`,
      },
      {
        title: "Add Member",
        icon: "bi-person-plus-fill",
        path: `/${tenantId}/memberAdd`,
      },
    ],
  },
  {
    title: "Settings",
    icon: "bi-gear-fill",
    childrens: [
      {
        title: "Add User",
        icon: "bi-person-plus-fill",
        path: `/${tenantId}/userAdd`,
      },
      {
        title: "Tenant Users",
        icon: "bi-people-fill",
        path: `/${tenantId}/tenantUsers`,
      },
      {
        title: "Social Media",
        icon: "bi-share",
        path: `/${tenantId}/integrations`,
      },
      {
        title: "Account",
        icon: "bi-gear-fill",
        path: `/${tenantId}/settings`,
      },
      {
        title: "Reset Password",
        icon: "bi-key-fill",
        path: `/${tenantId}/reset-password`,
      },
      {
        title: "Terms Of Use",
        icon: "bi-file-earmark-text",
        path: "/termsofuse",
      },
      {
        title: "Privacy Policy",
        icon: "bi-shield-lock-fill",
        path: "/privacypolicy",
      },
      {
        title: "Profile",
        icon: "bi-person-circle",
        path: "/profile",
      },
      {
        title: "Payment",
        icon: "bi-credit-card-2-front-fill",
        path: "/settings/billing/payment",
      },
      {
        title: "Subscription",
        icon: "bi-receipt",
        path: "/settings/billing/subscription",
      },
      {
        title: "Notifications",
        icon: "bi-bell-fill",
        path: "/settings/notifications",
      },
    ],
  },
];

export default sidebar;

